/**
 * Client-side input allowlists.
 * Letters, digits, and spaces are always allowed.
 * Special characters: only `_` and `@` (email also allows `.` and `-`).
 */

/** General text (names, company, job title, etc.) */
export function sanitizeTextInput(value) {
    if (typeof value !== "string") return ""
    return value.replace(/[^\p{L}\p{N}\s_@]/gu, "")
}

/** Email: keep `.` and `-` so addresses like you@company.com remain usable */
export function sanitizeEmailInput(value) {
    if (typeof value !== "string") return ""
    return value.replace(/[^\p{L}\p{N}_@.-]/gu, "")
}

/** OTP / numeric codes */
export function sanitizeDigitsInput(value) {
    if (typeof value !== "string") return ""
    return value.replace(/\D/g, "")
}
